import React, { useEffect, useState } from "react";
import styles from "./TermsAndConditions.module.css";
import { TextComponent } from "../../../components";
import termIcon from "../../../assets/termsandconditions-icon.png";
import { useDispatch, useSelector } from "react-redux";
import PagesMiddleware from "../../../Store/Middlewares/PagesMiddleware";
const TermsAndConditions = () => {
    const dispatch = useDispatch();
    const PagesData = useSelector(
      (state) => state?.PagesReducer.PagesInformation
    );
    const [loader, setloader] = useState(true);
    useEffect(() => {
      if (!PagesData) {
        getData();
      } else {
        setloader(false);
      }
    }, []);
    const getData = () => {
      dispatch(PagesMiddleware.getPagesInformation())
        .then((res) => {
          setloader(false);
        })
        .catch((err) => {
          setloader(false);
        });
    };
  return (
    <div>
      <div className={styles.termsConditionContainer}>
        <div className={styles.containerText}>
          <TextComponent textClass={styles.tcText}>
            {/* <p>Terms and Conditions for the "Best Day Ever" Wedding App:</p> */}
            <span
              className={styles.contentStyling}
              dangerouslySetInnerHTML={{ __html: PagesData?.terms }}
            />
          </TextComponent>
        </div>
        <div className={styles.containerIcon}>
          <img src={termIcon} alt="Terms and Conditions" />
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
